import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import GIF from "gif.js";

/* N */
/* Mofusand frame */
const drawMofusandFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/mofusand-frame.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

/* Crayon Shin Chan Frame */
const drawShinChanFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/shin-chan.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

/* Miffy Frame */
const drawMiffyFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/miffy-frame.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

/* Mary Wedding Frame */
const drawWeddingFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/wedding.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

/* Mark Frame */
const drawMarkFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/mm.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};


/* Jellycat frame */
const drawJellycatFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/jellycat.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

/* KSA frame */
const drawKsaFrame = (ctx, canvas) => {
  const frameImg = new Image();
  frameImg.src = '/tmu.png';
  
  frameImg.onload = () => {
    ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
  };
};

const frames = {
  none: {
    draw: (ctx, x, y, width, height) => {}, 
  },
  pastel: {
    draw: (ctx, x, y, width, height) => {
      const drawSticker = (x, y, type) => {
        switch(type) {
          case 'star':
            ctx.fillStyle = "#FFD700";
            ctx.beginPath();
            ctx.arc(x, y, 12, 0, Math.PI * 2);
            ctx.fill();
            break;
          case 'heart':
            ctx.fillStyle = "#cc8084";
            ctx.beginPath();
            const heartSize = 22;
            ctx.moveTo(x, y + heartSize / 4);
            ctx.bezierCurveTo(x, y, x - heartSize / 2, y, x - heartSize / 2, y + heartSize / 4);
            ctx.bezierCurveTo(x - heartSize / 2, y + heartSize / 2, x, y + heartSize * 0.75, x, y + heartSize);
            ctx.bezierCurveTo(x, y + heartSize * 0.75, x + heartSize / 2, y + heartSize / 2, x + heartSize / 2, y + heartSize / 4);
            ctx.bezierCurveTo(x + heartSize / 2, y, x, y, x, y + heartSize / 4);
            ctx.fill();
            break;
          case 'flower':
            ctx.fillStyle = "#FF9BE4";
            for(let i = 0; i < 5; i++) {
              ctx.beginPath();
              const angle = (i * 2 * Math.PI) / 5;
              ctx.ellipse(
                x + Math.cos(angle) * 10,
                y + Math.sin(angle) * 10,
                8, 8, 0, 0, 2 * Math.PI
              );
              ctx.fill();
            }
            // Center of flower
            ctx.fillStyle = "#FFE4E1";
            ctx.beginPath();
            ctx.arc(x, y, 6, 0, 2 * Math.PI);
            ctx.fill();
            break;
          case 'bow':
            ctx.fillStyle = "#f9cee7";
            // Left loop
            ctx.beginPath();
            ctx.ellipse(x - 10, y, 10, 6, Math.PI / 4, 0, 2 * Math.PI);
            ctx.fill();
            // Right loop
            ctx.beginPath();
            ctx.ellipse(x + 10, y, 10, 6, -Math.PI / 4, 0, 2 * Math.PI);
            ctx.fill();
            // Center knot
            ctx.fillStyle = "#e68bbe";
            ctx.beginPath();
            ctx.arc(x, y, 4, 0, 2 * Math.PI);
            ctx.fill();
            break;
        }
      };

         // Top left corner
         drawSticker(x + 11, y + 5, 'bow');
         drawSticker(x - 18, y + 95, 'heart');
         
         // Top right corner
         drawSticker(x + width - 160, y + 10, 'star');
         drawSticker(x + width - 1, y + 50, 'heart');
         
         // Bottom left corner
         drawSticker(x + 120, y + height - 20, 'heart');
         drawSticker(x + 20, y + height - 20, 'star');
         
         // Bottom right corner
         drawSticker(x + width - 125, y + height - 5, 'bow');
         drawSticker(x + width - 10, y + height - 45, 'heart');
       }
     },

  
  cute: {
    draw: (ctx, x, y, width, height) => {
      const drawStar = (centerX, centerY, size, color = "#FFD700") => {
        ctx.fillStyle = color;
        ctx.beginPath();
        for(let i = 0; i < 5; i++) {
          const angle = (i * 4 * Math.PI) / 5 - Math.PI / 2;
          const point = i === 0 ? 'moveTo' : 'lineTo';
          ctx[point](
            centerX + size * Math.cos(angle),
            centerY + size * Math.sin(angle)
          );
        }
        ctx.closePath();
        ctx.fill();
      };

      const drawCloud = (centerX, centerY) => {
        ctx.fillStyle = "#87CEEB";
        const cloudParts = [
          { x: 0, y: 0, r: 14 },
          { x: -6, y: 2, r: 10 },
          { x: 6, y: 2, r: 10 },
        ];
        cloudParts.forEach(part => {
          ctx.beginPath();
          ctx.arc(centerX + part.x, centerY + part.y, part.r, 0, Math.PI * 2);
          ctx.fill();
        });
      };

      // Draw decorations around the frame
        // Top corners
        drawStar(x + 150, y + 18, 15, "#FFD700");
        drawCloud(x + 20, y + 5);
        drawStar(x + width - 1, y + 45, 12, "#FF69B4");
        drawCloud(x + width - 80, y + 5);

        // Bottom corners
        drawCloud(x + 150, y + height - 5);
        drawStar(x + 0, y + height - 65, 15, "#9370DB");
        drawCloud(x + width - 5, y + height - 85);
        drawStar(x + width - 120, y + height - 5, 12, "#40E0D0");
   }
  },

  mofusandImage: {
    draw: (ctx, x, y, width, height) => {
    }
  }, 

  shinChanImage: {
    draw: (ctx, x, y, width, height) => {
    }
  },

  miffyImage: {
    draw: (ctx, x, y, width, height) => {
    }
  },
  weddingImage: {
    draw: (ctx, x, y, width, height) => {
    }
  },
  markImage: {
    draw: (ctx, x, y, width, height) => {
    }
  },
  jellycatImage: {
    draw: (ctx, x, y, width, height) => {
    }
  },
  ksaImage: {
    draw: (ctx, x, y, width, height) => {
    }
  }
};

const PhotoPreview = ({ capturedImages, selectedLayout }) => {
  const stripCanvasRef = useRef(null);
  const gifPreviewRef = useRef(null);
  const navigate = useNavigate();
  const [stripColor, setStripColor] = useState("white");
  const [selectedFrame, setSelectedFrame] = useState("none");
  const [email, setEmail] = useState("");  
  const [status, setStatus] = useState(""); 
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [isGeneratingQR, setIsGeneratingQR] = useState(false);
  const [qrCodeStatus, setQrCodeStatus] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isCreatingGif, setIsCreatingGif] = useState(false);
  const [gifBlob, setGifBlob] = useState(null);
  
  // Get layout information
  const layoutType = selectedLayout ? selectedLayout.type : "layoutA";
  const photoCount = selectedLayout ? selectedLayout.poses : 4;

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      })
      .catch(err => console.error("Failed to copy:", err));
  };

  const createGIF = async () => {
    if (capturedImages.length === 0 || isCreatingGif || gifBlob) {
      return gifBlob;
    }
    
    setIsCreatingGif(true);
    
    return new Promise((resolve, reject) => {
      try {
        const gif = new GIF({
          workers: 2,
          quality: 10,
          width: 400,
          height: 300,
          workerScript: '/gif.worker.js' // Make sure this file is in your public folder
        });
        
        let imagesLoaded = 0;
        const totalImages = capturedImages.length;
        
        capturedImages.forEach((imageUrl) => {
          const img = new Image();
          img.onload = () => {
            // Create a canvas to process the image with the same size for all frames
            const canvas = document.createElement('canvas');
            canvas.width = 400;
            canvas.height = 300;
            const ctx = canvas.getContext('2d');
            
            // Draw a background matching the strip color
            ctx.fillStyle = stripColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            
            // Center and fit the image
            const imageRatio = img.width / img.height;
            const canvasRatio = canvas.width / canvas.height;
            let drawWidth, drawHeight, startX, startY;
            
            if (imageRatio > canvasRatio) {
              drawHeight = canvas.height;
              drawWidth = img.width * (canvas.height / img.height);
              startX = (canvas.width - drawWidth) / 2;
              startY = 0;
            } else {
              drawWidth = canvas.width;
              drawHeight = img.height * (canvas.width / img.width);
              startX = 0;
              startY = (canvas.height - drawHeight) / 2;
            }
            
            // Draw the image
            ctx.drawImage(img, startX, startY, drawWidth, drawHeight);
            
            // Apply frame if needed
            if (frames[selectedFrame] && typeof frames[selectedFrame].draw === 'function') {
              frames[selectedFrame].draw(ctx, 0, 0, canvas.width, canvas.height);
            }
            
            // Add this frame to the GIF
            gif.addFrame(canvas, { delay: 500, copy: true }); // 500ms delay between frames
            
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              // Render the GIF when all images are added
              gif.on('finished', (blob) => {
                const gifUrl = URL.createObjectURL(blob);
                setGifBlob(blob);
                setIsCreatingGif(false);
                resolve(blob);
              });
              
              gif.on('error', (error) => {
                console.error("Error creating GIF:", error);
                setIsCreatingGif(false);
                reject(error);
              });
              
              gif.render();
            }
          };
          
          img.onerror = (error) => {
            console.error("Error loading image for GIF:", error);
            setIsCreatingGif(false);
            reject(error);
          };
          
          img.src = imageUrl;
        });
      } catch (error) {
        console.error("Error creating GIF:", error);
        setIsCreatingGif(false);
        reject(error);
      }
    });
  };

  const generatePhotoStrip = useCallback(() => {
    const canvas = stripCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
  
    // Basic dimensions for photo strips
    const imgWidth = 400;  
    const imgHeight = 300; 
    const borderSize = 40;  
    const photoSpacing = 20;  
    const textHeight = 50;
    
    // Configure canvas dimensions based on layout type
    let totalHeight;
    
    // Set up canvas dimensions based on the layout
    switch(layoutType) {
      case "layoutA": // 4 photos (default)
        totalHeight = (imgHeight * 4) + (photoSpacing * 3) + (borderSize * 2) + textHeight;
        break;
      case "layoutB": // 3 photos 
        totalHeight = (imgHeight * 3) + (photoSpacing * 2) + (borderSize * 2) + textHeight;
        break;
      case "layoutC": // 2 photos
        totalHeight = (imgHeight * 2) + (photoSpacing * 1) + (borderSize * 2) + textHeight;
        break;
      case "layoutD": // 6 photos (2x3 grid)
        //photos in a 2x3 grid
        totalHeight = (imgHeight * 3) + (photoSpacing * 2) + (borderSize * 2) + textHeight;
        canvas.width = (imgWidth * 2) + (photoSpacing) + (borderSize * 2);
        break;
      default:
        // Default to 4 photos
        totalHeight = (imgHeight * 4) + (photoSpacing * 3) + (borderSize * 2) + textHeight;
    }
    
    // For layouts A, B, and C (vertical strips)
    if (layoutType !== "layoutD") {
      canvas.width = imgWidth + borderSize * 2;
    }
    
    canvas.height = totalHeight;
  
    // Fill the background with the selected color
    ctx.fillStyle = stripColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  
    let imagesLoaded = 0;
    
    // Create a function to draw the text after all images have loaded
    const drawText = () => {
      const now = new Date();
      const timestamp = now.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }) + '  ' + 
      now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      
      ctx.fillStyle = (stripColor === "black" || stripColor === "800000") ? "#FFFFFF" : "#000000";
      ctx.font = "20px Arial";
      ctx.textAlign = "center";
      
      ctx.fillText("Picapica  " + timestamp, canvas.width / 2, totalHeight - borderSize * 1);
  
      ctx.fillStyle = (stripColor === "black" || stripColor === "800000") 
        ? "rgba(255, 255, 255, 0.5)" 
        : "rgba(0, 0, 0, 0.5)";
      ctx.font = "12px Arial";  
      ctx.textAlign = "center";
      ctx.fillText(
          "© 2025 AW",
          canvas.width - borderSize,
          totalHeight - borderSize / 2
      );
  
      // Draw the frame if mofusand or shin chan is selected
      if (selectedFrame === "mofusandImage") {
        drawMofusandFrame(ctx, canvas);
      } else if (selectedFrame === "shinChanImage") {
        drawShinChanFrame(ctx, canvas);
      } else if (selectedFrame === "miffyImage") {
        drawMiffyFrame(ctx, canvas);
      } else if (selectedFrame === "weddingImage") {
        drawWeddingFrame(ctx, canvas);
      } else if (selectedFrame === "markImage") {
        drawMarkFrame(ctx, canvas);
      } else if (selectedFrame === "jellycatImage") {
        drawJellycatFrame(ctx, canvas);
      } else if (selectedFrame === "ksaImage") {
        drawKsaFrame(ctx, canvas);
      }
    };

    // If there are no images, just draw the text and frames
    if (capturedImages.length === 0) {
      drawText();
      return;
    }
    
    // Handle actual photos we have (might be less than required)
    const imagesToUse = capturedImages.slice(0, photoCount);
    
    // Draw images based on layout
    imagesToUse.forEach((image, index) => {
      const img = new Image();
      img.src = image;
      img.onload = () => {
        let x, y;
        
        // Position the image based on the layout type
        if (layoutType === "layoutD") {
          // Layout D: 2x3 grid
          const col = index % 2;
          const row = Math.floor(index / 2);
          x = borderSize + col * (imgWidth + photoSpacing);
          y = borderSize + row * (imgHeight + photoSpacing);
        } else {
          // Layouts A, B, C: vertical strips
          x = borderSize;
          y = borderSize + (imgHeight + photoSpacing) * index;
        }
        
        const imageRatio = img.width / img.height;
        const targetRatio = imgWidth / imgHeight;
  
        let sourceWidth = img.width;
        let sourceHeight = img.height;
        let sourceX = 0;
        let sourceY = 0;
  
        if (imageRatio > targetRatio) {
            sourceWidth = sourceHeight * targetRatio;
            sourceX = (img.width - sourceWidth) / 2;
        } else {
            sourceHeight = sourceWidth / targetRatio;
            sourceY = (img.height - sourceHeight) / 2;
        }
  
        ctx.drawImage(
            img,
            sourceX, sourceY, sourceWidth, sourceHeight, 
            x, y, imgWidth, imgHeight      
        );
  
        if (frames[selectedFrame] && typeof frames[selectedFrame].draw === 'function') {
          frames[selectedFrame].draw(
              ctx,
              x,
              y,
              imgWidth,
              imgHeight
          );
        }
  
        imagesLoaded++;
  
        if (imagesLoaded === imagesToUse.length) {
          drawText();
        }
      };
      
      img.onerror = () => {
        console.error(`Failed to load image at index ${index}`);
        imagesLoaded++;
        if (imagesLoaded === imagesToUse.length) {
          drawText();
        }
      };
    });
  }, [capturedImages, stripColor, selectedFrame, layoutType, photoCount]);

  useEffect(() => {
    // Add a small delay to ensure the DOM is ready with the canvas element
    setTimeout(() => {
      generatePhotoStrip();
      
      // Start creating the GIF in the background if not already created
      if (!gifBlob && !isCreatingGif && capturedImages.length > 0) {
        createGIF().catch(error => console.error("Error creating background GIF:", error));
      }
    }, 100);
  }, [capturedImages, stripColor, selectedFrame, generatePhotoStrip, gifBlob, isCreatingGif, layoutType]);

  const downloadPhotoStrip = () => {
    // First, download the photo strip
    const link = document.createElement("a");
    link.download = "Picapica-photostrip.jpg";
    link.href = stripCanvasRef.current.toDataURL("image/jpeg", 0.8);
    link.click();
  };

  // Add the function to download GIF
  const downloadGIF = async () => {
    try {
      if (!gifBlob) {
        const blob = await createGIF();
        if (!blob) {
          alert("Sorry, there was an error creating the GIF.");
          return;
        }
      }
      
      // Create download link for the GIF
      const link = document.createElement("a");
      link.download = "Picapica-gif.gif";
      link.href = URL.createObjectURL(gifBlob);
      link.click();
    } catch (error) {
      console.error("Error downloading GIF:", error);
      alert("Sorry, there was an error creating the GIF.");
    }
  };

  const generateQRCode = async () => {
    try {
      setIsGeneratingQR(true);
      setQrCodeStatus("Generating QR code...");
      setQrCodeUrl(""); 

      // Create or get GIF if we have captured images
      let gifData = null;
      if (capturedImages.length > 0) {
        try {
          // If we already have a GIF blob, use it, otherwise create one
          const blob = gifBlob || await createGIF();
          if (blob) {
            // Convert blob to base64 for sending to backend
            gifData = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
          }
        } catch (error) {
          console.error("Error creating GIF for QR code:", error);
          // Continue even if GIF creation fails
        }
      }
      
      // Optimize the canvas image before sending
      const canvas = stripCanvasRef.current;
      
      // Create a smaller version of the image for QR code generation
      const optimizedCanvas = document.createElement('canvas');
      const targetWidth = 800; // Reduced from original size
      const aspectRatio = canvas.height / canvas.width;
      const targetHeight = targetWidth * aspectRatio;
      
      optimizedCanvas.width = targetWidth;
      optimizedCanvas.height = targetHeight;
      
      // Draw original canvas content to the smaller canvas
      const ctx = optimizedCanvas.getContext('2d');
      ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, targetWidth, targetHeight);
      
      // Use lower quality WebP for faster upload 
      const optimizedImageData = optimizedCanvas.toDataURL("image/jpeg", 0.85);
      
      // Add a timeout to ensure UI updates before the network request
      setTimeout(async () => {
        try {
          const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
          
          // Step 2: Send the optimized image to the server
          const response = await axios.post(`${BACKEND_URL}/generate-qr-code`, {
            imageData: optimizedImageData,
            gifData: gifData
          });
          
          if (response.data.success) {
            setQrCodeUrl(response.data.qrCodeDataUrl);
            setQrCodeStatus("Scan this QR code to view and download your photo strip!");
          } else {
            setQrCodeStatus(`Error: ${response.data.message}`);
          }
        } catch (error) {
          console.error("Error generating QR code:", error);
          setQrCodeStatus("Failed to generate QR code. Please try again.");
        } finally {
          setIsGeneratingQR(false);
        }
      }, 100); // Small timeout for UI update
    } catch (error) {
      console.error("Error preparing image:", error);
      setQrCodeStatus("Failed to prepare image. Please try again.");
      setIsGeneratingQR(false);
    }
  };
  
  return (
    <div className="photo-preview">
      <h2>Photo Strip Preview</h2>
      
      {/* Layout type indicator */}
      <div style={{ 
        margin: "10px auto", 
        padding: "5px 15px", 
        backgroundColor: "rgba(255, 153, 178, 0.2)", 
        borderRadius: "10px",
        display: "inline-block"
      }}>
        <p style={{ margin: 0, fontSize: "0.9rem" }}>
          Layout: {layoutType.replace('layout', 'Layout ')} ({photoCount} photos)
        </p>
      </div>

      {/* Main content layout with flexbox for the two-column layout */}
      <div style={{ 
        display: "flex", 
        flexDirection: "row", 
        flexWrap: "wrap", 
        justifyContent: "center", 
        alignItems: "flex-start",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "20px"
      }}>
        {/* Left column - Photo Strip */}
        <div style={{ 
          flex: "1 1 500px", 
          marginRight: "20px", 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center"
        }}>
          <canvas 
            ref={stripCanvasRef} 
            className="photo-strip" 
            style={{
              maxWidth: layoutType === "layoutD" ? "600px" : "400px",
              width: "100%",
              height: "auto",
              border: "1px solid #ddd",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
          />
          
          {isCreatingGif && (
            <p style={{ color: '#666', fontSize: '0.9rem', marginTop: '10px', textAlign: 'center' }}>
              Creating your GIF preview... This may take a few moments.
            </p>
          )}

          <div className="action-buttons" style={{ marginTop: "20px" }}>
            <button onClick={downloadPhotoStrip}>
              📥 Download Photo Strip
            </button>
            <button onClick={generateQRCode} disabled={isGeneratingQR}>
              {isGeneratingQR ? "Generating..." : "🔗 Download via QR Code"}
            </button>
            <button 
              onClick={downloadGIF} 
              disabled={isCreatingGif || capturedImages.length === 0}
            >
              {isCreatingGif ? "Creating GIF..." : "📥 Download GIF"}
            </button>
            <button onClick={() => navigate("/picapica-layout")}>🔄 Take New Photos</button>
          </div>

          {qrCodeUrl && (
            <div className="qr-code-section">
              <h3>QR Code</h3>
              <p>{qrCodeStatus}</p>
              <img 
                src={qrCodeUrl} 
                alt="QR Code for photo access" 
                style={{ 
                  maxWidth: "200px", 
                  margin: "10px auto", 
                  display: "block",
                  border: "1px solid #ddd",
                  padding: "10px",
                  background: "white",
                  borderRadius: "5px"
                }} 
              />

              <button onClick={() => copyToClipboard(qrCodeUrl)}>Copy Link</button>
              {copied && <p style={{ color: "green", fontSize: "14px" }}>Link copied!</p>}
              
              <p style={{ fontSize: "12px", color: "#666", margin: "10px 0" }}>
                This link will expire in 10 minutes
              </p>
            </div>
          )}
        </div>

        {/* Right column - Customization Options */}
        <div style={{ 
          flex: "1 1 300px", 
          display: "flex", 
          flexDirection: "column", 
          padding: "10px", 
          borderRadius: "10px"
        }}>
          <h3 style={{ textAlign: "center", marginBottom: "15px" }}>Customize your photo strip</h3>

          {/* Frame Color */}
          <div className="control-section">
            <p className="section-title">Frame colour</p>
            <div className="color-options" style={{ 
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "8px"
            }}>
              <button onClick={() => setStripColor("white")}>White</button>
<button onClick={() => setStripColor("black")}>Black</button>
<button onClick={() => setStripColor("#f6d5da")}>Pink</button>
<button onClick={() => setStripColor("#dde6d5")}>Green</button>
<button onClick={() => setStripColor("#adc3e5")}>Blue</button>
<button onClick={() => setStripColor("#FFF2CC")}>Yellow</button>
<button onClick={() => setStripColor("#dbcfff")}>Purple</button>
<button onClick={() => setStripColor("#800000")}>Maroon</button>
<button onClick={() => setStripColor("#845050")}>Burgundy</button>
              
{/* Color wheel option */}
<div style={{ 
  gridColumn: "span 2", 
  display: "flex", 
  alignItems: "center", 
  justifyContent: "center", 
  margin: "5px 0" 
}}>
  <label htmlFor="colorPicker" style={{ marginRight: "10px" }}>Custom: </label>
  <input 
    type="color" 
    id="colorPicker" 
    value={stripColor.startsWith('#') ? stripColor : '#ffffff'} 
    onChange={(e) => setStripColor(e.target.value)} 
    style={{ 
      width: "40px", 
      height: "40px", 
      borderRadius: "50%", 
      cursor: "pointer",
      border: "2px solid #ccc" 
    }} 
  />
</div>
            </div>
          </div>

          {/* Stickers */}
          <div className="control-section" style={{ marginTop: "20px" }}>
            <p className="section-title">Stickers</p>
            <div className="frame-options" style={{ 
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "8px"
            }}>
              <button onClick={() => setSelectedFrame("none")}>No Stickers</button>
              <button onClick={() => setSelectedFrame("pastel")}>Girlypop</button>
              <button onClick={() => setSelectedFrame("cute")}>Cute</button>
              <button onClick={() => setSelectedFrame("jellycatImage")}>Jellycat</button> {/* remove 5.1 */}
              <button onClick={() => setSelectedFrame("mofusandImage")}>Mofusand</button>
              <button onClick={() => setSelectedFrame("shinChanImage")}>Shin Chan</button>
              <button onClick={() => setSelectedFrame("miffyImage")}>Miffy</button>
              <button onClick={() => setSelectedFrame("markImage")}>Mark's Debut</button> {/* remove 4.30 */}
              <button onClick={() => setSelectedFrame("ksaImage")}>TMU - KSA</button> {/* remove 5.22 */}
            </div>
          </div>
        </div>
      </div>

      {/* Google AdSense In-article Ad */}
      <div style={{ margin: "20px auto", maxWidth: "450px" }}>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2065338109976469"
            crossOrigin="anonymous"></script>
        <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-2065338109976469"
            data-ad-slot="5782568466"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div>

      {/* Mondiad Native Ad Placement */}
      <div data-mndazid="271b449a-0c81-4ef0-8379-237125f2e40e"></div>
    </div>
  );
};

export default PhotoPreview;